export default "__VITE_ASSET__TZj5oQKj__"